import { useId, useLayoutEffect } from "react";
import {
  clearBottomBarActions,
  registerBottomBarActions,
} from "../stores/bottom-bar-actions-store";
import type { BottomBarAction } from "../stores/shell-bottom-bar";

/** Register contextual actions (Create, Save, etc.) for the fixed bottom bar. */
export function useBottomBarActions(buildActions: () => BottomBarAction[]): void {
  const ownerId = useId();
  const actions = buildActions();

  // Synchronous write during render. Layout renders <Outlet /> before <BottomNavBar />,
  // so the nav bar's useSyncExternalStore getSnapshot() sees these actions on first paint.
  registerBottomBarActions(ownerId, actions, false);

  useLayoutEffect(() => {
    registerBottomBarActions(ownerId, actions, true);
    return () => clearBottomBarActions(ownerId);
  });
}
